export enum IntegrationStatusTypes {
  Expired = 'AUTHENTICATION_EXPIRED',
}
